import { addTotalCadastreCount } from '../../helpers/cadastreForms/getFormField';
import { validatePhone } from '../../helpers';

export const responsiblePersonsFormsPercentGetter = (form, addAllDataLength, addFilledCount) => {
  form.responsiblePersons?.forEach((person) => {
    addAllDataLength(3);
    addTotalCadastreCount([{ name: 'fio', valid: (dataField) => dataField !== '' && dataField.length <= 255 }, {
      name: 'position',
      valid: (dataField) => dataField !== '' && dataField.length <= 255,
    }, {
      name: 'phone_num',
      valid: (dataField) => validatePhone(dataField),
    }], person, addFilledCount);
  });
};
